<!-- eslint-disable -->
<template>
<loading v-model:active="isLoading" :is-full-page="fullPage" />
<div id="auth">
    <div class="row h-100">
        <div class="col-lg-4 col-12">
            <div id="auth-left">
                <div class="auth-logo">
                    <router-link :to="{path: '/'}"><img src="/images/logo/logoBPP.png?ver=0.1.6" alt="Logo"></router-link>
                </div>
                <p class="auth-subtitle mb-3">Masukan Nomor Induk BPP (NIB) & Password</p>
                
                <form v-on:submit.prevent="logIn">
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl" v-model="formLogin.username" placeholder="NIB (Nomor Induk BPP)">
                        <div class="form-control-icon">
                            <i class="bi bi-bookmark-check"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="password" class="form-control form-control-xl" v-model="formLogin.password" placeholder="Password">
                        <div class="form-control-icon">
                            <i class="bi bi-shield-lock"></i>
                        </div>
                    </div>
                    <!--
                    <div class="form-check form-check-lg d-flex align-items-end">
                        <input class="form-check-input me-2" type="checkbox" value="" id="flexCheckDefault">
                        <label class="form-check-label text-gray-600" for="flexCheckDefault">
                            Keep me logged in
                        </label>
                    </div>
                    -->
                    <button class="btn btn-warning btn-block btn-lg shadow-lg mt-4">Log in</button>
                </form>

                <div class="text-center mt-5 text-lg fs-5">
                    <p class="text-gray-600">Belum Memiliki Akun? <router-link :to="{path: '/register'}" class="font-bold">Registrasi Akun</router-link>.</p>
                    <p><router-link :to="{path: '/forgot'}"  class="font-bold">Lupa Akun/Password</router-link>.</p>
                </div>
            </div>
        </div>
        <div class="col-lg-8 d-lg-block">
            <div id="auth-right">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="card bg-transparant">
                            <div class="bg-card"
                                style="position: absolute;height: 100%;background-color: #e1eefc;display: block;width: 100%; border-radius: 0.7rem; opacity: 0.2;">
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                    <h2 class=" text-dark text-left"><strong>Informasi</strong></h2>
                                    <p class="card-text text-dark">
                                        Sistem Pembayaran BPP Online Alkautsar Bandar Lampung digunakan untuk melihat Nomor Induk BPP (NIB) dan Nomor Virtual Account Bank (Nomor VA) serta melihat informasi Tagihan Siswa dan Riwayat Pembayaran BPP.
                                    </p>
                                     <h4 class="card-title text-dark text-left mt-2">Cara Registrasi Akun</h4>
                                        <ol class="card-text text-dark">
                                            <li>Siswa yang belum memiliki Akun dapat melakukan pendaftaran Akun dengan
                                                mengklik link <strong>REGISTRASI</strong> yang ada dibawah tombol Log In
                                            </li>
                                            <li>Setelah di Klik akan tampil halaman Registrasi Akun, Pada halaman Registrasi Akun
                                                anda diminta untuk memasukan Nama Lengkap dan Tanggal Lahir Siswa</li>
                                            <li>Setelah Nama Lengkap dan Tanggal Lahir dimasukan klik tombol
                                                <strong>CARI DATA SAYA</strong></li>
                                            <li>Kemudian akan ditampilkan Informasi Nomor Induk BPP (NIB) <i class="bi bi-bookmark-check"></i> dan Biodata Siswa. Jika biodata yang
                                                ditampikan sudah sesuai dengan biodata anda, lalu isikan Password yang
                                                anda inginkan. <br>
                                                <label class="text-danger">Catatan : username login yang ditampilkan adalah NIB (Nomor Induk BPP) siswa, orang tua siswa diharapkan menghafalkan Nomor Induk BPP (NIB) siswa</label> <br>
                                            </li>
                                            <li>Langkah terakhir klik tombol <strong>DAFTAR AKUN</strong></li>
                                        </ol>
                             
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<!-- eslint-disable -->
<script>
  import axios from "axios";
  import Loading from "vue-loading-overlay";

  export default {
    name: "Login",
    components: {
      Loading
    },
    data() {
      return {
        formLogin : {
            username : '',
            password : '',
        },
        isLoading: false,
        fullPage: true,
      };
    },
    mounted() {
      this.loadPageRegister();
    },
    methods: {
      async loadPageRegister() {
        this.isLoading = true;
        setTimeout(() => {
            this.isLoading = false;
          },1000);
      },
      async logIn() {
        this.isLoading = true;
        this.$store
          .dispatch("postLogin", JSON.stringify(this.formLogin))
          .then((response) => {
            setTimeout(() => {
              this.isLoading = false;
            },100);
            if (response.data.code === '200') {
              this.$router.push("/dashboard");
            } else {
              Swal.fire({
                icon: "warning",
                title: "Maaf !",
                text: response.data.message,
              })
            }
          });
      },
    },
  };
</script>
